// src/utils/scrollUtils.ts
export const scrollToInput = (currentInput: HTMLElement | null) => {
  if (!currentInput) return;

  // Находим ближайший контейнер, в котором находится инпут
  const container = currentInput.closest('.ios-input-container');
  if (!container) return;

  // Пытаемся найти следующий контейнер с классом ios-input-container
  let nextContainer = container.nextElementSibling;
  while (nextContainer && !nextContainer.classList.contains('ios-input-container')) {
    nextContainer = nextContainer.nextElementSibling;
  }

  if (nextContainer) {
    // Если следующий контейнер найден, ищем в нем инпут
    const nextInput = nextContainer.querySelector('input');
    if (nextInput) {
      nextInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  }

  // Если следующего инпута нет, значит текущий — последний.
  // Прокручиваем к кнопке, у которой класс начинается с "StyledButton"
  const submitButton = document.querySelector('[class^="StyledButton"]');
  if (submitButton) {
    submitButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};